import { gql } from '@apollo/client'

export const Query = gql`
  query MultiplierType($companyId: ID!, $filters: MultiplierTypeFilters, $order: MultiplierTypeOrder, $after: String, $before: String, $first: Int, $last: Int) {
    multiplierTypes(companyId: $companyId, filters: $filters, order: $order, after: $after, before: $before, first: $first, last: $last) {
      nodes {
        id
        name
        multiplier
        multiplierType
        operandQuantity
        operandType
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
